import { render } from "./header2.vue?vue&type=template&id=4d2d54bc"
import script from "./header2.vue?vue&type=script&lang=js"
export * from "./header2.vue?vue&type=script&lang=js"

import "./header2.vue?vue&type=style&index=0&id=4d2d54bc&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__